// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2TQtH","selected":"Chip_selected__lllPt"};